// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1AypV","checkboxCol":"Table_checkboxCol__29Dsk","emailCol":"Table_emailCol__3j6EY","actionCol":"Table_actionCol__2Ylcv"};